import { SVGProps, memo } from 'react';

function ChevronLeftIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <path d="M16.25 20.5L7.75 12L16.25 3.5" stroke={props?.stroke ? props.stroke : '#333'} strokeLinecap="round" />
    </svg>
  );
}

export default memo(ChevronLeftIcon);
